var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIc16Email(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.375L17.5 15C17.5 15.6411 17.0175 16.1694 16.3958 16.2416L16.25 16.25H3.75002C3.10897 16.25 2.58063 15.7675 2.50843 15.1458L2.50002 15L2.5 5.375L9.17689 10.9407C9.64817 11.3531 10.3519 11.3531 10.8231 10.9407L17.5 5.375ZM15.5412 3.75L10 8.33906L4.4575 3.75H15.5412Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc16Email);
export default __webpack_public_path__ + "static/media/ic16-email.123760ebf8087579d14bcf553c18d3c8.svg";
export { ForwardRef as ReactComponent };